import { FilterModalTypes } from '..';
import { hasAutocompleteSelection, AutocompleteTypes } from '../filters/Autocomplete';
import { BooleanTypes, hasBooleanSelection } from '../filters/Boolean';
import { DateTypes, hasDateSelection } from '../filters/Date';
import { DateRangeTypes, hasDateRangeSelection } from '../filters/DateRange';
import { hasMultiSliderSelection, MultiSliderTypes } from '../filters/MultiSlider';
import { hasRangeSelection, RangeTypes } from '../filters/Range';
import { hasSectionSelection, SectionTypes } from '../filters/Section';
import { hasSelectSelection, SelectTypes } from '../filters/Select';
import { hasTagsSelection, TagsTypes } from '../filters/Tags';

export const filterHasSelection = (
  filterType: FilterModalTypes.FilterAtom['availableFilters'][number]['type'],
  selection: FilterModalTypes.SelectedFiltersProps['filter'],
  filter: FilterModalTypes.FilterType
) => {
  switch (filterType) {
    case 'autocomplete':
      return hasAutocompleteSelection(selection as AutocompleteTypes.SelectionProps);

    case 'date':
      return hasDateSelection(selection as DateTypes.SelectionProps);

    case 'dateRange':
      return hasDateRangeSelection(selection as DateRangeTypes.SelectionProps);

    case 'multiSlider':
      return hasMultiSliderSelection(
        selection as MultiSliderTypes.RangeProps,
        filter as MultiSliderTypes.Props
      );

    case 'section':
      return hasSectionSelection(selection as SectionTypes.SelectionProps);

    case 'tags':
      return hasTagsSelection(selection as TagsTypes.SelectionProps);

    case 'select':
      return hasSelectSelection(selection as SelectTypes.SelectionProps);

    case 'range':
      return hasRangeSelection(selection as RangeTypes.RangeProps, filter as RangeTypes.Props);

    case 'boolean':
      return hasBooleanSelection(selection as BooleanTypes.SelectionProps);

    default:
      return false;
  }
};
